import React, { useEffect, useState } from "react";

import axios, { MEDIA_BASE_URL } from "../../axios/axios";

const SwiperBanner = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get("/banner/");
        setBanners(response.data);
      } catch (error) {
        console.error("Error fetching banners", error);
      }
    };

    fetchBanners();
  }, []);

  return (
    <>
      <div
        id="carouselExampleInterval"
        class="carousel slide"
        data-bs-ride="carousel"
      >
        <div class="carousel-inner">
          {banners.map((banner, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              data-bs-interval="2000"
            >
              <img
                src={`${MEDIA_BASE_URL}/${banner.imageUrl}`}
                crossOrigin="anonymous"
                className="d-block w-100 object-fit-cover hero-banner-img"
                alt="banner"
              />
            </div>
          ))}
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </>
  );
};

export default SwiperBanner;
